import { Injectable } from '@angular/core';
import { mailBoxApi } from '../../constants/mailbox-api';
import { BehaviorSubject, Observable } from 'rxjs';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { HttpClientService } from '../httpClient/httpClient.service';
import { MatDialog } from '@angular/material/dialog';
import { SelectionWarningComponent } from 'src/app/views/mail-box/shared/selection-warning/selection-warning.component';

@Injectable({
    providedIn: 'root',
})
export class MailBoxService {
    checkMails = new BehaviorSubject<boolean>(false);
    checkMails$ = this.checkMails.asObservable();
    mail_type: any = [];
    pagination_config: PaginationType = {
        size: 50,
        total: 0,
        skip: 0,
        limit: 50,
    };
    dashboard_counts: any;
    checkDashboardCounts = new BehaviorSubject<object>({});
    checkDashboardCounts$ = this.checkDashboardCounts.asObservable();
    checkFronSidebar = new BehaviorSubject<boolean>(false);
    checkFronSidebar$ = this.checkFronSidebar.asObservable();
    updateMailCounts = new BehaviorSubject<object>({});
    mailFolders = new BehaviorSubject<any>(undefined);
    updateMailBody = new BehaviorSubject<any>(undefined);
    selectedMailType = new BehaviorSubject<any>(undefined);

    constructor(
        private httpClientService: HttpClientService,
        public dialog: MatDialog
    ) { }

    getIncomingMail(
        pagination: any,
        type: any,
        search: string,
        domain_mail: any,
        moreFilters: any = null,
        userType?: string,
        universityIds?,
        caseOwnerId?,
        myMails?: boolean | any,
        mailId?: boolean
    ): Observable<any> {
        let query = '?';
        query += `type=${type}&`;
        if (search) {
            query += `search=${search}&`;
        }
        if (domain_mail) {
            query += `domain=${domain_mail.domain}&email=${domain_mail.mail}&`;
        }

        if (moreFilters && moreFilters?.key) {
            query += `${moreFilters?.key}=${moreFilters.value}&`;
        }
        if (userType) {
            query += `${userType}=${true}&`;
        }
        if (universityIds && universityIds.length) {
            query += `universityId=${universityIds}&`;
        }

        if (caseOwnerId) {
            query += `caseOwnerId=${caseOwnerId}&`;
        }

        if (myMails !== undefined) {
            query += `myMails=${myMails}&`;
        }
        if(mailId){
            query += `myMails=${false}&`;
        }

        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${mailBoxApi.getIncomingMail}${query}`
        );
    }

    getMailDetailsById(id: any, receiptMailId?: string): Observable<any> {
        let query = '?';
        if (receiptMailId) {
            query += `receiptMailId=${receiptMailId}`
        }
        const url = `${mailBoxApi.getMailDetailsById}/${id}${query}`;
        return this.httpClientService.post(url, {});
    }

    sendMail(params: any, payload: any): Observable<any> {
        return this.httpClientService.upload(
            `${mailBoxApi.sendMail}${params}`,
            payload
        );
    }

    assignMail(payload: any) {
        return this.httpClientService.put(
            `${mailBoxApi.assignMail}${payload}`,
            {}
        );
    }

    bulkUpdate(payload: any) {
        return this.httpClientService.put(
            `${mailBoxApi.bulkUpdate}${payload}`,
            {}
        );
    }

    getMailsByAppId(id: any, pagination: PaginationType): Observable<any> {
        const url = `${mailBoxApi.getMailsByAppId}${id}&skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(url);
    }

    updateCommunicationMail(id: any, payload: any) {
        return this.httpClientService.put(
            `${mailBoxApi.updateCommunicationMail}${id}`,
            payload
        );
    }

    // getDashboardCounts(): Observable<any> {
    //   const url = `${mailBoxApi.getDashboardCounts}`;
    //   return this.httpClientService.get(url);
    // }

    getDashboardCounts(email?: string): Observable<any> {
        let url = `${mailBoxApi.getDashboardCounts}`;
        if (email) {
            url += `?email=${email}`;
        }
        return this.httpClientService.get(url);
    }

    downloadMail(payload: any): Observable<any> {
        const url = `${mailBoxApi.downloadMail}${payload.messageId}&subject=${payload.subject}`;
        return this.httpClientService.eml(url, {});
    }

    uploadMail(payload: any): Observable<any> {
        const url = `${mailBoxApi.uploadMail}?agentId=${payload.agentId}&messageId=${payload.messageId}&subject=${payload.subject}`;
        return this.httpClientService.eml(url, {});
    }

    openWarningPopup(type: string) {
        const dialogRef = this.dialog.open(SelectionWarningComponent, {
            width: '30%',
            enterAnimationDuration: '300ms',
            exitAnimationDuration: '100ms',
            data: {
                type: type,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
            }
        });
        dialogRef.afterOpened().subscribe((result) => {
            setTimeout(() => {
                dialogRef.close();
            }, 3000);
        });
    }

    updateRead(message_id: any, read: any, receiptMailId?: string) {
        let query = '';
        if (receiptMailId) {
            query += `&receiptMailId=${receiptMailId}`
        }

        return this.httpClientService.put(
            `${mailBoxApi.updateRead}${message_id}&isRead=${read}${query}`,
            {}
        );
    }

    createFolder(user_id: string, payload: any) {
        return this.httpClientService.put(
            `${mailBoxApi.createFolder}${user_id}`,
            payload
        );
    }
    addNewMailFolder(payload: any) {
        return this.httpClientService.post(
            `${mailBoxApi.addNewMailFolder}`,
            payload
        );
    }

    saveDraft(params: any, payload: any): Observable<any> {
        return this.httpClientService.upload(
            `${mailBoxApi.saveDrafts}${params}`,
            payload
        );
    }

    getDashboardCountsV2(email?: string, domain?: string, userType?: string, universityIds?: string, myMails?: boolean): Observable<any> {
        let url = `${mailBoxApi.getDashboardCountsV2}`;
        if (email) {
            url += `?email=${email}`;
        }
        if (domain) {
            url += `&domain=${domain}`;
        } else {
            const domain = email.split('@')[1];
            url += `&domain=${domain}`;
        }
        if (userType) {
            url += `&${userType}=${true}`;
        }
        if (universityIds) {
            url += `&universityId=${universityIds}`;
        }
        if (myMails) {
            url += `&myMails=${myMails}`;
        }
        return this.httpClientService.get(url);
    }

    set updateMailCount(data: any) {
        this.updateMailCounts.next(data);
    }
    get updateMailCount(): Observable<any> {
        return this.updateMailCounts.asObservable();
    }
    set mailFoldersData(data: any) {
        this.mailFolders.next(data);
    }
    get mailFoldersData(): Observable<any> {
        return this.mailFolders.asObservable();
    }
    set reloadMailBody(data: any) {
        this.updateMailBody.next(data);
    }
    get reloadMailBody(): Observable<any> {
        return this.updateMailBody.asObservable();
    }

    set setSelectedMailType(data: any) {
        this.selectedMailType.next(data);
    }
    get getSelectedMailType(): Observable<any> {
        return this.selectedMailType.asObservable();
    }

    updateMailFolder(folderId: string, payload: any = null): Observable<any> {
        let query = '?';
        if (folderId) {
            query += `Id=${folderId}`;
        }
        return this.httpClientService.put(
            `${mailBoxApi.addNewMailFolder}${query}`,
            payload
        );
    }

    getCalederData(email: string, startDate: string, endDate: string) {
        let query = '?';
        if (email) {
            query += `email=${email}`;
        }
        if (startDate) {
            query += `&startDate=${startDate}`;
        }
        if (endDate) {
            query += `&endDate=${endDate}`;
        }
        return this.httpClientService.get(
            `${mailBoxApi.getCalenderEvents}${query}`
        );
    }

    convertToIST(dateTime: string, timeZone: string) {
        const startDateGMT = Number(dateTime);
        const startDate = new Date(startDateGMT * 1000); // Multiply by 1000 to convert seconds to milliseconds

        // Convert Date object to IST timezone
        const istDate = new Date(startDate.toLocaleString('en-US'));

        return istDate.toString();
    }

    getCurrentTimezone(): string {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    getMailRule(pagination?: any): Observable<any> {
        let query = '?';
        if (pagination) {
            query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        }
        return this.httpClientService.get(
            `${mailBoxApi.mailRule}${query}`
        );
    }
    addMailRule(payload: any = null): Observable<any> {
        return this.httpClientService.post(
            `${mailBoxApi.mailRule}`,
            payload
        );
    }
    updateMailRule(payload: any = null, id: string): Observable<any> {
        let params = '?';
        if (id) {
            params += `id=${id}`
        }
        return this.httpClientService.put(
            `${mailBoxApi.mailRule}${params}`,
            payload
        );
    }
}
